import BaseNotification from "./BaseNotification.vue";
import BaseLoading from "./BaseLoading.vue";
import BasePageLayout from "./BasePageLayout.vue";
import BaseConfirmModal from "./BaseConfirmModal.vue";
import BaseDatePicker from "./BaseDatePicker.vue";
import BaseEditor from "./BaseEditor.vue";
import BaseModal from "./BaseModal.vue";

const components = [
  { name: "d-notification", component: BaseNotification },
  { name: "d-loading", component: BaseLoading },
  { name: "d-page-layout", component: BasePageLayout },
  { name: "d-confirm-modal", component: BaseConfirmModal },
  { name: "d-date-picker", component: BaseDatePicker },
  { name: "d-editor", component: BaseEditor },
  { name: "d-modal", component: BaseModal },
];

export default components;
